module.exports = __webpack_public_path__ + "static/media/next.c87cad80.svg";